export default "__VITE_ASSET__f523985a__"